import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { usePrismItemStore } from 'stores/usePrismItemStore';

export const useAllSlotsStore = create(subscribeWithSelector((set, get) => ({
  totalSlots: null,
  stackablePhotoSlotCount: null,
  totalAndStackablePhotoSlotCount: null,
  showUploadPhoto: null,
  isLoading: true,
  error: null,

  updateTotalSlots: async () => {
    try {
      set({ isLoading: true, error: null });
      const store = usePrismItemStore.getState();
      const totalSlots = await store.totalNumberPhotoSlots();
      const stackablePhotoSlotCount = await store.totalNumberStackablePhotoSlots();
      const totalAndStackablePhotoSlotCount = totalSlots + stackablePhotoSlotCount;
      const showUploadPhoto = totalSlots + stackablePhotoSlotCount > 0;

      set({ totalSlots, stackablePhotoSlotCount, totalAndStackablePhotoSlotCount, showUploadPhoto, isLoading: false });
      return totalSlots;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  resetTotalSlots: () => set({ totalSlots: null, stackablePhotoSlotCount: null, totalAndStackablePhotoSlotCount: null, showUploadPhoto: null, error: null, isLoading: true }),

  // Subscribe to changes in PrismItemStore's total slots
  subscribeToChanges: () => {
    // Initial fetch
    get().updateTotalSlots();

    // Re-evaluate whenever PrismItem changes (e.g. page added/removed, theme switch)
    return usePrismItemStore.subscribe(
      async () => {
        await get().updateTotalSlots();
      }
    );
  },
})));
